import { type ComputedRef } from 'vue'

import { useMappedGetter } from '@/store'

/**
 * Global application scope providing access to core brand and location context
 */
export interface ApplicationScope {
  activeBrandId: ComputedRef<string>
  activeLocationId: ComputedRef<string | undefined>
}

/**
 * Returns the global application scope
 *
 * @returns The application scope with brand and location context
 */
export function useApplicationScope(): ApplicationScope {
  // TODO: uncomment this after the new brand view has been released + feature flag turned on
  // ticket: https://linear.app/owner/issue/RES-3794/re-add-inject-pattern
  /**
   * If the ACTIVE_BRAND_CONTEXT_KEY is set, that means we are inside the
   * ActiveBrandProvider and that we definitely have data in the store. This allows us
   * to ignore the potential of an undefined value for activeBrandId
   */
  // if (!injectLocal(ACTIVE_BRAND_CONTEXT_KEY)) {
  //   throw new Error(
  //     'should not use useApplicationScope outside of the active brand context'
  //   )
  // }

  const activeBrandId = useMappedGetter<string>('core/brand/active/id')
  const activeLocationId = useMappedGetter<string | undefined>(
    'core/location/active/id'
  )

  return {
    activeBrandId,
    activeLocationId,
  }
}
